const customFocus = {
    inserted(el, binding) {
        if(el.tagName.toLocaleLowerCase() == 'textarea') {
            el.focus()
        }else{
            if(el.getElementsByTagName('textarea')) {
                el.getElementsByTagName('textarea')[0].focus()
            }
        } 
    },
}
export default customFocus